import { Rate } from "antd";
import React from "react";
import ViewRatings from "../Model/ViewRatings";
import Awards from "./Awards";
import { formatProfileTitle } from "../Utils";

const ProfileBio = ({ Rating, type, id, data, sportType, current, profile, isOrganizer }) => {
  return (
    <div className="sideItem">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 className="timelineAboutpadding">{formatProfileTitle(current)}</h1>
        <h1 style={{ color: "#0085FF" }} className="fs-16">
          {sportType
            ? `${profile?.typeofsports || "SportType"}_${
                profile?.nameofsports || profile?.sportsyouplay || "SportsYouPlay"
              }`
            : " "}
        </h1>
      </div>

      <p>
        {profile?.description
          ? profile.description
          : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ipsum aenean suspendisse eget eu"}
      </p>
      <hr />
      {type && (
        <>
          <h1 className="timelineAboutpadding">Rating</h1>
          <div
            style={{ display: "flex", alignItems: "center", fontSize: "20px", fontWeight: "500" }}>
            {parseFloat(Rating || 0).toFixed(1)}
            <Rate
              disabled
              allowHalf
              value={Rating || 0}
              defaultValue={Rating || 0}
              style={{ fontSize: "30px", marginLeft: "10px" }}
            />
          </div>
          {type && id ? <ViewRatings t1ype={type} id={id} /> : null}
        </>
      )}
      {!isOrganizer && <Awards type={type} data={type === "event" ? data : profile} />}
    </div>
  );
};

export default ProfileBio;
